import { render, staticRenderFns } from "./AccreditationDocument.vue?vue&type=template&id=cea315be&scoped=true"
import script from "./AccreditationDocument.vue?vue&type=script&lang=js"
export * from "./AccreditationDocument.vue?vue&type=script&lang=js"
import style0 from "./AccreditationDocument.vue?vue&type=style&index=0&id=cea315be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea315be",
  null
  
)

export default component.exports